// This file can be replaced during build by using the `fileReplacements` array.
// `ng bui.ld --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDTyIjnU9Wro8IVgZ1hllHWAQaZvkGlfNM",
    authDomain: "orbitec-ec337.firebaseapp.com",
    databaseURL: "https://orbitec-ec337.firebaseio.com",
    projectId: "orbitec-ec337",
    storageBucket: "orbitec-ec337.appspot.com",
    messagingSenderId: "728379193623",
    appId: "1:728379193623:web:87d0ce45eaa45c858a1f52",
    measurementId: "G-V41JDE9W1S"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
